<template>
  <div class="stats is-margin-top">

    <section>
      <div class='container'>


      </div>

    </section>

  </div>
</template>

<script>
  export default {
    name: 'main_page',
    data () {
      this.$parent.active_tab = 'main_page'
      return {
        activeTab: 0
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue